import { api } from "./client";
import type {
  AttemptHistoryItem,
  CategoryCreate,
  CategoryDetail,
  CategoryUpdate,
  PaginatedResponse,
  Question,
} from "@/types";

export const categoriesApi = {
  getAll() {
    return api.get<CategoryDetail[]>("/categories");
  },

  getBySlug(slug: string) {
    return api.get<CategoryDetail>(`/categories/${slug}`);
  },

  getQuestions(slug: string, page = 1, pageSize = 10) {
    return api.get<PaginatedResponse<Question>>(`/categories/${slug}/questions`, {
      page,
      page_size: pageSize,
    });
  },

  recordAttempt(slug: string, data: { score: number; total_questions: number; passed: boolean; time_taken_seconds?: number }) {
    return api.post<AttemptHistoryItem>(`/categories/${slug}/attempts`, data);
  },

  create(data: CategoryCreate) {
    return api.post<CategoryDetail>("/categories", data);
  },

  update(slug: string, data: CategoryUpdate) {
    return api.patch<CategoryDetail>(`/categories/${slug}`, data);
  },

  delete(slug: string) {
    return api.delete<void>(`/categories/${slug}`);
  },
};
